import {
    Menu,
    MenuItem,
    ProSidebarProvider,
    Sidebar,
    SubMenu,
} from "react-pro-sidebar";
import { Link, useNavigate } from "react-router-dom";
import dashboard from "../../assets/images/icon1.svg";
import template from "../../assets/images/icon5.svg";
import team from "../../assets/images/icon3.svg";
import report from "../../assets/images/icon8.svg";
import folderIcon from "../../assets/images/sidebarFolderIcon.svg";
import entity from "../../assets/images/icon9.svg";
import schedule from "../../assets/images/scheduler.svg";
import announcement from "../../assets/images/icon6.svg";
import activityLog from "../../assets/images/activityLog.svg";
import bell from "../../assets/images/bell.svg";
import productList from "../../assets/images/productList.svg";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setRoute } from "../../redux/route/routeSlice";

export default function LeadCoordinatorSidebar(props) {
    const [activePage, setActivePage] = useState(null);
    const [dropdown, setDropdown] = useState("");
    const navigation = useNavigate();
    const dispatch = useDispatch();
    const reduxData = useSelector((state) => state);

    const getFolderName = () => {
        if (reduxData?.folders?.folderStructure?.length) {
            let name = reduxData?.folders?.folderStructure[0]?.name;
            return name;
        }
    };

    useEffect(() => {
        if (reduxData?.heading?.value?.includes("Leads")) {
            setDropdown("Leads");
        }
    }, [reduxData?.heading?.value]);

    function handleActive(event, heading) {
        let activeA = document.querySelector("a.active");
        if (activeA) {
            activeA.classList.remove("active");
        }
        dispatch(setRoute(heading));
        if (!event.target.classList.value.includes("active")) {
            event.target.classList.toggle("active");
            if (activePage) activePage.classList.remove("active");
            setActivePage(event.target);
        }
    }

    const leadLink = () => {
        let activeSpan = document.querySelector("span.active");
        if (activeSpan) {
            activeSpan.classList.remove("active");
        }
        setDropdown(dropdown === "Leads" ? "" : "Leads");
        dispatch(setRoute("Leads"));
        navigation("/lead-coordinator/leads/all");
    };

    return (
        <ProSidebarProvider>
            <Sidebar>
                <Menu>
                    <MenuItem
                        onClick={(e) => {
                            setDropdown("");
                            handleActive(e, "Dashboard");
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/lead-coordinator"
                            />
                        }
                    >
                        <img src={dashboard} alt="dashboard" />
                        Dashboard
                    </MenuItem>

                    <SubMenu
                        icon={<img src={template} alt="setting" />}
                        className="settings"
                        label="Leads"
                        onClick={leadLink}
                        open={dropdown === "Leads"}
                    >
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Leads");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/lead-coordinator/leads/all"
                                />
                            }
                        >
                            All Leads
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Leads");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/lead-coordinator/leads/assigned"
                                />
                            }
                        >
                            Assigned Leads
                        </MenuItem>

                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Leads");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/lead-coordinator/leads/unassigned"
                                />
                            }
                        >
                            Unassigned Leads
                        </MenuItem>
                    </SubMenu>

                    <MenuItem
                        onClick={(e) => {
                            setDropdown("");
                            handleActive(e, "Entities");
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/lead-coordinator/entities"
                            />
                        }
                    >
                        <img src={entity} alt="Entities" /> Entities
                    </MenuItem>

                    <MenuItem
                        onClick={(e) => {
                            setDropdown("");
                            handleActive(e, "Report");
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/lead-coordinator/report"
                            />
                        }
                    >
                        <img src={report} alt="Form Template" /> Reports
                    </MenuItem>

                    <MenuItem
                        onClick={(e) => {
                            setDropdown("");
                            handleActive(e, "Scheduler");
                        }}
                        routerLink={
                            <Link onClick={props.menuClick} to="/schedule" />
                        }
                    >
                        <img src={schedule} alt="Form Template" />
                        Scheduler
                    </MenuItem>

                    {/* <MenuItem
                        onClick={(e) => {
                            handleActive(e, "Notification");
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/notification"
                            />
                        }
                    >
                        <img src={bell} alt="Form Template" />
                        Notification
                    </MenuItem> */}

                    <MenuItem
                        onClick={(e) => {
                            setDropdown("");
                            handleActive(e, "Activity Logs");
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/activity-log"
                            />
                        }
                    >
                        <img src={activityLog} alt="Form Template" />
                        Activity Logs
                    </MenuItem>

                    <MenuItem
                        onClick={(e) => {
                            setDropdown("");
                            handleActive(e, "PDPA");
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/announcements-list"
                            />
                        }
                    >
                        <img src={announcement} alt="Form Template" />
                        PDPA
                    </MenuItem>

                    <MenuItem
                        onClick={(e) => {
                            setDropdown("");
                            handleActive(e, "Product");
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/product-list"
                            />
                        }
                    >
                        <img src={productList} alt="Form Template" />
                        Product
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            handleActive(e, getFolderName());
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/folder-structure"
                            />
                        }
                    >
                        <img src={folderIcon} alt="Folder" />
                        {getFolderName()}
                    </MenuItem>
                </Menu>
            </Sidebar>
        </ProSidebarProvider>
    );
}
